import React from "react";
import classnames from "classnames";

import _str from "shared/util/_str";
import Actions from "okpay/actions/Actions";
import TextInput from "okpay/util/TextInput";

class Name extends React.Component {
	_onChange = (e) => {
		const { value } = e.target;
		Actions.updateField({ name: value });
	};

	render() {
		const classes = classnames({
			"okpay-item": true,
			"okpay-item-name": true,
		});

		return (
			<div className={classes}>
				<div className="okpay-item-element">
					<TextInput
						value={this.props.value}
						name="name"
						label={_str("Cardholder Name")}
						autoComplete="on"
						onChange={this._onChange}
					/>
				</div>
			</div>
		);
	}
}

export default Name;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/fields/Name.jsx